<template lang="">
  <div data-cy="tournament-card-container">
    <v-card
      :color="useDetectedColor ? color : undefined"
      :to="{ name: 'event', params: { tournamentId: tournament.id } }"
      data-cy="tournament-card-link"
    >
      <div class="d-flex align-center">
        <v-avatar class="ma-3" size="75px" rounded="lg" data-cy="tournament-avatar-container">
          <v-img :src="avatar" data-cy="tournament-avatar-image" @load="loadPalette"></v-img>
        </v-avatar>
        <div class="d-flex flex-column w-100">
          <v-card-title data-cy="tournament-name">
            {{ tournament.name }}
          </v-card-title>
          <v-card-text class="w-100 d-flex justify-space-between">
            <div class="d-flex flex-column">
              <div data-cy="tournament-dates">
                <v-icon>mdi-calendar</v-icon>
                {{ startDate }} {{ startDate === endDate ? '' : `- ${endDate}` }}
              </div>
              <div v-if="tournament.isOnline" data-cy="tournament-online-status">
                <v-icon>mdi-wifi</v-icon>
                Online
              </div>
              <div v-else data-cy="tournament-location">
                <v-icon>mdi-map-marker</v-icon>
                {{ tournament.city }}, {{ tournament.countryCode }}
              </div>
              <div data-cy="tournament-attendees">
                <v-icon>mdi-account</v-icon>
                {{ tournament.numAttendees }} Attendees
              </div>
              <div data-cy="tournament-events">
                <v-icon>mdi-card-multiple</v-icon>
                {{ tournament.events.length }} Events
              </div>
            </div>
          </v-card-text>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { format } from 'date-fns'
import * as Vibrant from 'node-vibrant'
import { useTheme } from 'vuetify'

export default {
  props: {
    tournament: {
      type: Object,
      required: true
    },
    useDetectedColor: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup() {
    let { current } = useTheme()

    return { current }
  },
  data: function () {
    return {
      palette: null
    }
  },
  computed: {
    avatar() {
      return this.tournament?.images?.find((image) => image.type === 'profile')?.url || ''
    },
    startDate() {
      return format(new Date(this.tournament.startAt * 1000), 'MMM d, yyyy')
    },
    endDate() {
      return format(new Date(this.tournament.endAt * 1000), 'MMM d, yyyy')
    },
    color() {
      return this.current.dark ? this.palette?.DarkVibrant.hex : this.palette?.LightVibrant.hex
    }
  },
  methods: {
    loadPalette() {
      Vibrant.from(this.avatar)
        .getPalette()
        .then((palette) => {
          this.palette = palette
        })
        .catch(() => {
          this.palette = null
        })
    }
  }
}
</script>

<style lang=""></style>
